export class ClsErrores {
  Error: string;
  ErrorDescripcion: string;
}

export class ClsErrores2 {
  error: string;
  errorDescripcion: string;
  Error?: string;
  ErrorDescripcion?: string;
}
